/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const Forward = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(classes.root, className)}
      onClick={onClick}
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M13 14H11C9.3596 13.9994 7.75023 14.4471 6.34588 15.2949C4.94152 16.1427 3.7956 17.3582 3.032 18.81C3.01054 18.5405 2.99986 18.2703 3 18C3 12.477 7.477 8 13 8V3L23 11L13 19V14Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Forward;
